import React, { useEffect, useState } from 'react'
import Confirmation from './confirmation';
import { ICartContextType } from '../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../ShoppingCart/shoppingcart';
import helperfunctions from "../../../utils/helperfunctions";
import partsService from "../../../services/partsservice";
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from '../../../state/features/header';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { RESOURCE } from '../../../const/resource';
import { useTranslation } from "react-i18next";
import { IContainerProps } from './confirmationInterface';

const ConfirmationContainer = (props: IContainerProps) => {

  const { stepperDetails, cartsDetails }: ICartContextType = useCartContext();
  const [confirmationSummaryData, setConfirmationSummaryData] = useState<any>({ loading: false, data: {} });
  const [orderSummaryData, setOrderSummaryData] = useState<any>({ loading: false, data: {} });
  const [errMsg, setErrMsg] = useState<any>({ isEmpty: '', isError: false });
  const [sendNotificationRes, setSendNotificationRes] = useState({ loading: false, data: {} })
  const [printResponse, setPrintResponse] = useState<any>({ loading: false, data: {} })
  const [orderConfirmationDetails, setOrderConfirmationDetails] = useState<any>({ loading: false, data: {} })
  const [isAddForFuture, setIsAddForFuture] = React.useState(false);
  const [shareOrderConfirmationRes, setShareOrderConfirmationRes] = useState<any>({ loading: false, data: {} });
  const [addForFutureRes, setaddForFutureRes] = useState<any>({ loading: false, data: {} });
  const [primaryContact, setPrimaryContact] = useState<any>([]);
  const [secondaryContact, setSecondaryContact] = useState<any>([]);
  const [orderConfirmationDetailsUpdated, setOrderConfirmationDetailsUpdated] = useState<any>({})

  const { t } = useTranslation();

  const {
    headercurrentuser,
    globalData
  }: any = useSelector(
    state => ({
      headercurrentuser: headerSelector.currentuser(state),
      globalData: globalDataSelector.globaldata(state)
    })
  );

  const [isAddMore, setIsAddMore] = useState(false)
  const [inputValue, setInputValue] = useState<any>([]);

  const getValueByType = (type: any, index: any) => {
      const filteredItems: any = Array.isArray(secondaryContact) ? secondaryContact.filter((item: any) => (item?.type && item?.type?.toLowerCase()) === type) : {};
     return filteredItems?.[index]?.value || '';
  };

    const getValueByTypeForPhone = (type: any, index: any) => {
        const phoneNumber = getValueByType('sms', index);
        if (type == "mobile") {
            return phoneNumber?.length > 0 ? phoneNumber.substring(phoneNumber.indexOf(' ') + 1) : '';;
        }
        else {
            return phoneNumber?.length > 0 ? phoneNumber.substring(0, phoneNumber.indexOf(' ')) : '';
        }
    };

    const onAddMore = () => {
        setInputValue([{ email: getValueByType('email', 0), mobile: getValueByTypeForPhone("mobile", 0), phoneCode: getValueByTypeForPhone("phoneCode", 0), key: 0, isLastMobile: true, isLastEmail: true }])
        setIsAddMore(true);
    }

    const CheckNullOrEmpty = (value : any) => {
        return value || ""
    }

    useEffect(() => {
    if (orderConfirmationDetails?.data?.cartId && orderSummaryData?.data && Object.keys(orderSummaryData?.data)) {
      const { notification } = orderConfirmationDetails?.data ?? {};
        const orderContact = orderSummaryData?.data?.shippingInfo?.contact ?? {};
      const { primary, secondary, updatedData } = Array.isArray(notification) ? notification.reduce((acc: any, item: any) => {
          if ((item?.type && item?.type.toLowerCase() === 'email' && item?.value === orderContact?.email) ||
              (item?.type && item?.type.toLowerCase() === 'sms' && item?.value?.replace(" ", "") === (CheckNullOrEmpty(orderContact?.phoneCountryCode) + CheckNullOrEmpty(orderContact?.phone))?.replace(" ", ""))) {
          item['isPrimary'] = true;
          item['isSecondary'] = false;
          acc.primary.push(item);
        } else {
          item['isPrimary'] = false;
          item['isSecondary'] = true;
          acc.secondary.push(item);
        }
        acc.updatedData.push(item);
        return acc;
      }, { primary: [], secondary: [], updatedData: [] }) : { primary: [], secondary: [], updatedData: [] };

      setPrimaryContact(primary);
      setSecondaryContact(secondary);
      setOrderConfirmationDetails({ loading: false, data: { ...orderConfirmationDetails.data, notification: updatedData } });
    }
  }, [orderSummaryData, orderConfirmationDetailsUpdated]);

  const handleAddInput = (index: any) => {
    if (inputValue?.[index]?.email) {
      let obj = [...inputValue ?? {}];
      const { isDuplicateMail, isErrorMail, isSentMail, updatedInputValue } = isDuplicateValidCheck(obj);
      obj = updatedInputValue;
      const lastField = inputValue?.[index + 1] ?? {};
      const isValid = !isSentMail && !isErrorMail && !isDuplicateMail;
      if (isValid) {
        obj[index + 1] = { ...lastField, email: getValueByType('email', index + 1), key: index, isLastEmail: true }
        obj[index] = { ...obj[index], isLastEmail: false }
      } else {
        obj[obj?.length - 1] = { ...obj[obj?.length - 1], isLastEmail: true }
      }
      setInputValue(obj);
    }
  };

  const handleAddMobile = (index: any) => {
    const digitsOnly = inputValue?.[index]?.mobile.replace(/\D/g, '');
    if (digitsOnly) {
      let obj = [...inputValue ?? {}];
      const { isDuplicateMob, isErrorMob, isSentMob, updatedInputValue } = isDuplicateValidCheck(obj);
      obj = updatedInputValue;
      const lastField = inputValue?.[index + 1] ?? {};
      const isValid = !isSentMob && !isErrorMob && !isDuplicateMob;
        if (isValid) {
            obj[index + 1] = { ...lastField, mobile: getValueByTypeForPhone('mobile', index + 1), phoneCode: getValueByTypeForPhone('phoneCode', index + 1), key: index, isLastMobile: true }
        obj[index] = { ...obj[index], isLastMobile: false }
      } else {
        obj[obj?.length - 1] = { ...obj[obj?.length - 1], isLastMobile: true }
      }
      setInputValue(obj);
    }
  };

  const handleChange = (event: any, index: number) => {
    let { name, value } = event.target;
    let updatedInputs = [...inputValue];
    updatedInputs[index] = { ...updatedInputs[index], [name]: value ? value?.trim() : '', isSentMail: false, isValidEmail: true, isDuplicateEmail: false };
    setInputValue(updatedInputs)
    setErrMsg({});
  };

  const handleChangeMobile = (event: React.ChangeEvent<HTMLInputElement>, index: number, propertyName: string) => {
      const { value } = event?.target ?? '';
      let updatedInputs = [...inputValue];
      const phoneNum = updatedInputs[index]?.phoneCode == "+1" ? value : value?.replace(/\D/g, '');
      updatedInputs[index] = { ...updatedInputs[index], [propertyName]: phoneNum??'', isSentSms: false, isValidMobile: true, isDuplicateMobile: false };
      setInputValue(updatedInputs);
      setErrMsg({});
  };

    const handleChangePhoneCode = (value: any, index: number, propertyName: string) => {
        let valueSplit = value.split("|"); 
        let val = valueSplit?.length > 0 ? valueSplit[0] : "";
        let updatedInputs = [...inputValue];
        const phone = updatedInputs[index]?.mobile ?? '';
        const inputPhone = val == '+1' ? helperfunctions.formatPhoneNumber(phone) : phone?.replace(/\D/g, '');
        updatedInputs[index] = { ...updatedInputs[index], [propertyName]: val, mobile: inputPhone, isSentSms: false, isValidMobile: true, isDuplicateMobile: false };
        setInputValue(updatedInputs);
        setErrMsg({});
    };


  const getConfirmationSummaryDetails = async () => {
    try {
      setConfirmationSummaryData({ loading: true, data: [] });
      const reqBody = {
        cartId: cartsDetails?.cart?.cartId,
        userAadId: headercurrentuser?.azureADId ?? '',
      }
      const response: any = await partsService.getConfirmationSummaryDetails(reqBody);
      if (response?.isSuccess) {
        setConfirmationSummaryData({ loading: false, data: response?.data ?? {} });
      } else {
        setConfirmationSummaryData({ loading: false, data: [] });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setConfirmationSummaryData({ loading: false, data: [] });
      helperfunctions.showErrorMessage(error);
    }
  }

    const getOrderConfirmationDetails = async () => {
    try {
      setOrderConfirmationDetails({ loading: true, data: [] });
      setOrderConfirmationDetailsUpdated({})
      const reqBody = {
        cartId: cartsDetails?.cart?.cartId,
        userAadId: headercurrentuser?.azureADId ?? '',
      }
      const response: any = await partsService.getOrderConfirmationDetails(reqBody);
        if (response?.isSuccess) {
            response?.data?.reminders?.forEach((t: any) => {
              helperfunctions.showRemainderMessageTop(`${t}`, 'remainderToaster');
            })
            if (response?.data?.pickupNotification)
            {
                helperfunctions.showSuccessMessageTop(response?.data?.pickupNotification);
            }
        setOrderConfirmationDetails({ loading: false, data: response?.data ?? {} });
        setOrderConfirmationDetailsUpdated(response?.data ?? {})
      } else {
        setOrderConfirmationDetails({ loading: false, data: [] });
        setOrderConfirmationDetailsUpdated({})
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setOrderConfirmationDetails({ loading: false, data: [] });
      setOrderConfirmationDetailsUpdated({})
      helperfunctions.showErrorMessage(error);
    }
  }

  const getOrderSummaryDetails = async () => {
    try {
      setOrderSummaryData({ loading: true, data: [] });
      const reqBody = {
        cartId: cartsDetails?.cart?.cartId,
        userAadId: headercurrentuser?.azureADId ?? '',
      }
        const response: any = await partsService.getOrderSummaryDetails(reqBody)
      if (response?.isSuccess) {
        setOrderSummaryData({ loading: false, data: response?.data ?? {} });
      } else {
        setOrderSummaryData({ loading: false, data: [] });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setOrderSummaryData({ loading: false, data: [] });
      helperfunctions.showErrorMessage(error);
    }
  }


  useEffect(() => {
    getConfirmationSummaryDetails();
    getOrderConfirmationDetails();
    getOrderSummaryDetails();
  }, []);

    const getOrderConfirmationAttachmentUrl = async () => {
        try {
            const reqBody = {
                cartId: orderConfirmationDetails?.data?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? ''
            }
            const response: any = await partsService.printOrderConfirmation(reqBody);
            if (response?.isSuccess && response?.data?.isSuccessful && response?.data?.sasUrl) {
                return response?.data?.sasUrl;
            } else {
                return null;
            }
        }
        catch (error: any) {
            return null;
        }
    }

  const onPrintOrderConfirmation = async () => {
    try {
      setPrintResponse({ loading: true, data: [] });
      const reqBody = {
          cartId: orderConfirmationDetails?.data?.cartId ?? 0,
          userAadId: headercurrentuser?.azureADId ?? ''
      }
      const response: any = await partsService.printOrderConfirmation(reqBody);
      if (response?.isSuccess) {
        if (response?.data?.isSuccessful) {
          if (response?.data?.sasUrl) {
            window.open(response?.data?.sasUrl, '_blank');
          }
        } else {
          helperfunctions.showErrorMessage(response?.data?.message);
        }
        setPrintResponse({ loading: false, data: response?.data ?? {} });
      } else {
        setPrintResponse({ loading: false, data: [] });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setPrintResponse({ loading: false, data: [] });
      helperfunctions.showErrorMessage(error);
    }
  }

  const emailDuplicateCheck = (val: any, seenEmails: any, isSentMailFlg: boolean) => {
    let isErrorEmail = false;
    let isDuplicateEmail = false;
    let isSentEmail = false;
    if (isSentMailFlg) {
      val = { ...val, isValidEmail: true, isDuplicateEmail: false, isSentMail: true }
      isSentEmail = true;
    } else {
      if (val?.email && !helperfunctions.validEmailCheck(val?.email)) {
        val = { ...val, isValidEmail: false, isDuplicateEmail: false, isSentMail: false }
        isErrorEmail = true;
      } else {
        if (val?.email && seenEmails.has(val?.email)) {
          isDuplicateEmail = true;
        }
        val = { ...val, isSentMail: false, isValidEmail: true, isDuplicateEmail }
      }
    }
    return { isDuplicateEmail, isErrorEmail, val, isSentEmail };
  }

    const mobileDuplicationCheck = (val: any, seenMobiles: any, isSentSmsFlg: boolean) => {
    let isDuplicateMobile = false;
    let isErrorMobile = false;
    let isSentSms = false;

        if (isSentSmsFlg) {
            val = { ...val, isValidMobile: true, isDuplicateMobile: false, isSentSms: true }
            isSentSms = true;
        }
        else if ((val.mobile && val.phoneCode && !helperfunctions.validPhoneCheckWithPhoneCode(val.mobile, val.phoneCode)) || (val.mobile && !val.phoneCode) || ((!val.mobile && val.phoneCode))) {
            val = { ...val, isValidMobile: false, isDuplicateMobile: false, isSentSms: false }
            isErrorMobile = true;
        }
        else if (val.mobile && val.phoneCode && seenMobiles.has(val.phoneCode + val.mobile)) {
            isDuplicateMobile = true;
            val = { ...val, isSentSms: false, isValidMobile: true, isDuplicateMobile:true }
        }

        return { isDuplicateMobile, isErrorMobile, val, isSentSms };
  }

  const getEmailSms = (notificationArr: any) => {
    return notificationArr.reduce((acc: any, curr: any) => {
      if (curr?.type?.toLowerCase() === 'email' && (curr?.isPrimary === true || curr?.isPrimary == undefined)) {
        acc.emailValues.push(curr.value);
      } else if (curr?.type?.toLowerCase() === 'sms' && (curr?.isPrimary === true || curr?.isPrimary == undefined)) {
        acc.smsValues.push(curr.value);
      }
      return acc;
    }, { emailValues: [], smsValues: [] });
    }

    const getIsTrueOrOtherValue = (isTrue: any, otherValue: any) => {
        return (isTrue ? true : otherValue);
    }

    const isDuplicateValidCheck = (inputValue: any) => {
    let isErrorMob = false;
    let isDuplicateMob = false;
    let isErrorMail = false;
    let isDuplicateMail = false;
    let isSentMail = false;
    let isSentMob = false;
    const seenMobiles = new Set();
    const seenEmails = new Set();
    const { notification } = orderConfirmationDetails?.data ?? {};
    const notificationArr = notification?.length > 0 ? notification : [];
    const { emailValues, smsValues } = getEmailSms(notificationArr);
    const updatedInputValue = inputValue.map((val: any) => {
      const { isDuplicateEmail, isErrorEmail, val: updatedValEmail, isSentEmail }: any = emailDuplicateCheck(val, seenEmails, emailValues.some((value: any) => value === val?.email));
      val = updatedValEmail;
      if (isDuplicateEmail === false) { seenEmails.add(val?.email); }
        isErrorMail = getIsTrueOrOtherValue(isErrorMail,isErrorEmail);
        isDuplicateMail = getIsTrueOrOtherValue(isDuplicateMail ,isDuplicateEmail);
        isSentMail = getIsTrueOrOtherValue(isSentMail, isSentEmail);
        const { isDuplicateMobile, isErrorMobile, val: updatedVal, isSentSms }: any = mobileDuplicationCheck(val, seenMobiles, smsValues.some((value: any) => value === val?.mobile));
        val = updatedVal;
        if (isDuplicateMobile === false) { seenMobiles.add(val?.phoneCode + val?.mobile); }
        isErrorMob = getIsTrueOrOtherValue(isErrorMob ,isErrorMobile);
        isDuplicateMob = getIsTrueOrOtherValue(isDuplicateMob, isDuplicateMobile);
        isSentMob = getIsTrueOrOtherValue(isSentMob ,isSentSms);
      return val;
    });
    if (isDuplicateMail || isErrorMail || isSentMail) {
      updatedInputValue[updatedInputValue.length - 1] = { ...updatedInputValue[updatedInputValue.length - 1], isLastEmail: true }
    }
    if (isDuplicateMob || isErrorMob || isSentMob) {
      updatedInputValue[updatedInputValue.length - 1] = { ...updatedInputValue[updatedInputValue.length - 1], isLastMobile: true }
    }
    return { isDuplicateMob, isDuplicateMail, isErrorMail, isErrorMob, isSentMob, isSentMail, updatedInputValue };
  }

  const checkHasData = () => {
    return inputValue.some((obj: any) => {
      return obj.email !== '' || obj.mobile !== '';
    })
  }

  const validationCheck = (inputValue: any) => {
    let isValid = true;
    const hasValueInData = checkHasData();
    let isDuplicate = false;
    if (hasValueInData) {
      const { isDuplicateMob, isDuplicateMail, isErrorMail, isErrorMob, isSentMob, isSentMail, updatedInputValue } = isDuplicateValidCheck(inputValue);
      isDuplicate = isDuplicateMob || isDuplicateMail || isErrorMail || isErrorMob || isSentMob || isSentMail;
      setInputValue(updatedInputValue);
    }
    if (!hasValueInData || isDuplicate) {
      isValid = false
    }
    setErrMsg({ isDuplicate: isDuplicate, isEmpty: !hasValueInData })
    return isValid;
  }

  const getEmailAndMobileLists = () => {
    const inputValueArr = inputValue?.length > 0 ? inputValue : [];
      const { emailList, mobileList } = inputValueArr.reduce((acc: any, obj: any) => {
          if (obj?.email?.length > 0) {
              acc.emailList.push({ emails: obj.email});
          }
          if (obj?.mobile?.length > 0 && obj?.phoneCode?.length > 0) {
              acc.mobileList.push({ phoneNumbers: obj.phoneCode + " " + (obj.mobile??"")?.replace(/\D/g, '') });
          }
      return acc;
    }, { emailList: [], mobileList: [] });

    return { emailList, mobileList };
  };

  const removeEmptyFields = () => {
    inputValue.forEach((obj: any) => {
      Object.keys(obj).forEach(key => {
        if (obj[key] === "") {
          delete obj[key];
        }
      });
    });
    setInputValue([...inputValue]);
  }

  const sendNotification = async () => {
    try {
      setSendNotificationRes({ loading: true, data: {} });
      const { emailList, mobileList } = getEmailAndMobileLists();
        const reqBody = {
        mykReferenceId: orderConfirmationDetails?.data?.mykReferenceNumber,
        emails: emailList,
        phoneNumbers: mobileList,
        cartid: orderConfirmationDetails?.data?.cartId,
        userAadId: headercurrentuser?.azureADId ?? '',
        customerName: globalData?.CustomerName
      }
      const response: any = await partsService.sendNotification(reqBody);
      if (response?.isSuccess) {
        if (response?.data?.isSuccessful) {
          setErrMsg({});
          removeEmptyFields();
          if (isAddForFuture) {
            addForFutureService(isAddForFuture);
          }
          helperfunctions.showSuccessMessage(response?.data?.message ?? t(RESOURCE.MyK_Label_SC_Notification_Success_Msg));
        } else {
          helperfunctions.showErrorMessage(response?.data?.message);
        }
        setSendNotificationRes({ loading: false, data: response?.data ?? {} });
      } else {
        setSendNotificationRes({ loading: false, data: {} });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setSendNotificationRes({ loading: false, data: {} });
      helperfunctions.showErrorMessage(error);
    }
  }

  const onClickSend = () => {
    const isValid = validationCheck(inputValue);
    if (isValid) {
      sendNotification();
    }
  }

  const addForFutureService = async (isChecked: boolean) => {
    try {
      setaddForFutureRes({ loading: true, data: [] });
      const reqBody = {
        userAadId: headercurrentuser?.azureADId ?? '',
        markForFutureOrder: isChecked,
        cartId: orderConfirmationDetails?.data?.cartId,
      }
      const response: any = await partsService.addForFuture(reqBody);
      if (response?.isSuccess) {
        if (!response?.data?.isSuccess) {
          helperfunctions.showErrorMessage(response?.data?.message);
        } else {
          helperfunctions.showSuccessMessage(response?.data?.message);
        }
        setaddForFutureRes({ loading: false, data: response?.data ?? {} });
      } else {
        setaddForFutureRes({ loading: false, data: {} });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setaddForFutureRes({ loading: false, data: {} });
      helperfunctions.showErrorMessage(error);
    }
  }

    const shareOrderConfirmation = async () => {
    try {
      setShareOrderConfirmationRes({ loading: true, data: [] });
      const reqBody = {
          cartId: orderConfirmationDetails?.data?.cartId,
          userAadId: headercurrentuser?.azureADId ?? '',
        }
      const attachmentUrl = await getOrderConfirmationAttachmentUrl();
      const response: any = await partsService.shareOrderConfirmation(reqBody)
      if (response?.isSuccess) {
        helperfunctions.shareOrderConfirmation(response?.data, attachmentUrl, t);
        setShareOrderConfirmationRes({ loading: false, data: response?.data ?? {} });
      } else {
        setShareOrderConfirmationRes({ loading: false, data: [] });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setShareOrderConfirmationRes({ loading: false, data: [] });
      helperfunctions.showErrorMessage(error);
    }
  }

  const onAddForFuture = (isChecked: boolean) => {
    setIsAddForFuture(isChecked);
    addForFutureService(isChecked);
  }

  return (
    <Confirmation
          onPrintOrderConfirmation={onPrintOrderConfirmation}
          orderSummaryData={orderSummaryData}
          stepperDetails={stepperDetails}
          onAddMore={onAddMore}
          handleChangeMobile={handleChangeMobile}
          handleChangePhoneCode={handleChangePhoneCode}
          handleChange={handleChange}
          handleAddInput={handleAddInput}
          handleAddMobile={handleAddMobile}
          isAddMore={isAddMore}
          inputValue={inputValue}
          onClickSend={onClickSend}
          errMsg={errMsg}
          sendNotificationRes={sendNotificationRes}
          printResponse={printResponse}
          orderConfirmationDetails={orderConfirmationDetails}
          onAddForFuture={onAddForFuture}
          shareOrderConfirmationRes={shareOrderConfirmationRes}
          shareOrderConfirmation={shareOrderConfirmation}
          addForFutureRes={addForFutureRes}
          confirmationSummaryData={confirmationSummaryData}
          globalData={globalData}
          primaryContact={primaryContact}
          secondaryContact={secondaryContact}
          phoneCodeOption={props.phoneCodeOption}
    />
  )
}

export default ConfirmationContainer